<template>
  <v-btn flat type="submit" @click="changePassword">
    <v-icon>vpn_key</v-icon>
  </v-btn>
</template>

<script>

export default {
  name: 'changePassword',
  methods: {
    changePassword () {
      this.$router.push('/changePassword')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePasswordIcon.vue